// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ob4v","footer":"styles_footer__JnR1V","passCodeTooltip":"styles_passCodeTooltip__24CIg"};